export const WEBSITE_SCHEMA_VERSION = 1;

export function normalizePath(pathname) {
  const value = String(pathname || '/').split('?')[0].split('#')[0];
  if (!value || value === '/') return '/';
  return `/${value.replace(/^\/+|\/+$/g, '')}`;
}

export function validateSnapshot(snapshot) {
  const errors = [];
  if (!snapshot || typeof snapshot !== 'object') errors.push('Website snapshot must be an object.');
  if (snapshot?.schemaVersion !== WEBSITE_SCHEMA_VERSION) errors.push(`Unsupported schema version: ${snapshot?.schemaVersion ?? 'missing'}.`);
  if (!Array.isArray(snapshot?.pages) || snapshot.pages.length === 0) errors.push('At least one page is required.');
  return errors;
}

export function findPage(snapshot, pathname) {
  const requested = normalizePath(pathname);
  return snapshot?.pages?.find((page) => normalizePath(page.slug) === requested) ?? null;
}
